import React, { useState } from "react";
import { X } from "lucide-react";
import { apiDelete } from "../../API/Api_Url";
import { toast } from "react-toastify";
import { Button } from "@headlessui/react";

function ContractorDeleteTrackerModal({ isOpen, onClose, fetchAllTracker, tracker }) {

    const [IsLoading, setIsLoading] = useState(false);

    const handleDelete = async () => {
        try {
            setIsLoading(true);

            const response = await apiDelete(`api/contractor/DeleteRequiremetTracker/${tracker?._id}`);

            if (response?.data) {
                toast.success(response?.message || "Bid deleted successfully!");
                onClose();
                fetchAllTracker()
            } else {
                toast.error(response?.message || "Failed to delete bid");
            }
        } catch (error) {
            console.error("Error deleting bid:", error);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };



    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 backdrop-blur-sm">
            <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-6">
                <div className="flex justify-between items-center border-b pb-3">
                    <h2 className="text-lg font-semibold text-gray-800">Delete Tracker</h2>
                    <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
                        <X className="h-5 w-5" />
                    </button>
                </div>

                <div className="py-5">
                    <p className="text-gray-600 text-center">
                        Are you sure you want to delete this tracker? <br />
                        This action <span className="font-semibold text-red-600">cannot be undone.</span>
                    </p>
                </div>
                <div className="flex justify-end gap-3 border-t pt-3">
                    <Button
                        onClick={onClose}
                        variant="outline"
                        className="rounded-xl px-4"
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={() => { handleDelete() }}
                        className="bg-red-600 hover:bg-red-700 text-white rounded-xl px-4"
                    >
                        {IsLoading ? "Please wait" : "Delete"}
                    </Button>
                </div>
            </div>
        </div>
    );
}

export default ContractorDeleteTrackerModal;
